import { FamilyAnswerStatsDto } from '@families-link/shared';
import { FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CellAction, CoreTableActionsCell } from '../../../_core/components/_ui/core-table';
import { EyeIcon } from '../../../_core/components/icons';
import { FamilyAnswerTableHandlers } from './families-responses-table.component';

export interface SessionsTableActionsProps extends FamilyAnswerTableHandlers {
	familyAnswer: FamilyAnswerStatsDto;
}

export const FamilyAnswerTableActions: FC<SessionsTableActionsProps> = (props) => {
	const { familyAnswer, onView } = props;
	const [t] = useTranslation();

	const handleViewDistrict = useCallback(() => {
		if (!familyAnswer) {
			return;
		}

		onView?.(familyAnswer);
	}, [onView, familyAnswer]);

	const actions = useMemo<CellAction[]>(
		() => [
			{
				id: 'view',
				type: 'button',
				tooltipTitle: t('buttons.tooltips.full-details'),
				props: {
					children: <EyeIcon sx={{ fontSize: 30 }} color="primary" />,
					onClick: handleViewDistrict,
				},
			},
		],
		[handleViewDistrict]
	);

	return <CoreTableActionsCell actions={actions} />;
};
